import { api } from '../../../utils/api'
import authTokenHeader from '../../../common/functions/authTokenHeader'

const dashboardApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getProfile: builder.query({
            query: () => {
                const authToken = authTokenHeader();
                if (!authToken || !authToken.Authorization) {
                    throw new Error('Authorization token is missing');
                }
                return {
                    url: `/user/my/profile`,
                    headers: {
                        ...authToken,
                    }
                }
            },
            providesTags: ['profile']
        }),
        updateProfile: builder.mutation({
            query: (body) => {
                return {
                    url: `/user/my/profile-update/`,
                    method: 'put',
                    body: body,
                    headers: {
                        ...authTokenHeader(),
                    }
                }
            },
            invalidatesTags: ['profile']
        }),
        getMyJobs: builder.query({
            query: (args) => {
                let { currentEmployer, filter, sort, search, page, page_size } = args;
                if (currentEmployer === undefined || page === undefined || page_size === undefined) {
                    return false;
                }
                let query = `/jobmanager/my/jobs/?employer=${currentEmployer}`;

                if (filter) {
                    query += `&filter_by=${filter}`;
                }
                if (sort) {
                    query += `&sort_by=${sort}`;
                }
                if (search) {
                    query += `&s=${search}`;
                }
                query += `&page=${page}&page_size=${page_size}`;
                const authToken = authTokenHeader();
                if (!authToken || !authToken.Authorization) {
                    throw new Error('Authorization token is missing');
                }
                return {
                    url: query,
                    headers: {
                        ...authToken,
                    },
                };
            },
            providesTags: ['Jobs'],
        }),
        getMyEmployers: builder.query({
            query: () => {
                return {
                    url: `/jobmanager/my/employers`,
                    headers: {
                        ...authTokenHeader(),
                    }
                }
            },
            transformResponse: (rawData) => {
                if (!rawData) return [];
                return rawData.map((item) => ({
                    value: item.id,
                    label: item.name,
                }))
            },
            providesTags: ['Employers'],
        }),
        getJobPackages: builder.query({
            query: () => {
                return {
                    url: `/jobmanager/my/purchased-packages`,
                    headers: {
                        ...authTokenHeader(),
                    }
                }
            },
            providesTags: ['purchasedPackages'],
        }),
        getJobStatuses: builder.query({
            query: () => {
                return {
                    url: `/jobmanager/job-statuses`,
                }
            },
            providesTags: ['jobStatus'],
        }),
        deleteJob: builder.mutation({
            query: (slug) => {
                return {
                    url: `/jobmanager/job/${slug}`,
                    method: 'DELETE',
                    headers: {
                        ...authTokenHeader(),
                    }
                }
            },
            invalidatesTags: ['Jobs'],
        }),
        resetPassword: builder.mutation({
            query: (body) => {
                return {
                    url: `/user/reset-password/`,
                    method: 'post',
                    body: body,
                }
            },
        }),
        getMyAccount: builder.query({
            query: () => {
                return {
                    url: `user/myaccount/`,
                    method: 'get',
                    headers: {
                        ...authTokenHeader(),
                    }
                }
            },
            providesTags: ['myaccount'],
        }),
    }),
})

export const {
    useGetProfileQuery,
    useGetMyJobsQuery,
    useGetJobPackagesQuery,
    useGetJobStatusesQuery,
    useGetMyEmployersQuery,
    useDeleteJobMutation,
    useResetPasswordMutation,
    useUpdateProfileMutation

} = dashboardApi